<template>
    <div>
        <div class="page-header pr-0">
            <h2 style="color: #3333337d;">
                <a href="/dashboard">
                    <i class="fas fa-tachometer-alt"></i>
                </a>
            </h2>
            <ol class="breadcrumbs">
                <li class="active"><span>Usuarios</span></li>
            </ol>
            
        </div>
        <div class="card mb-0">
            <div class="card-header bg-info mb-0 custom-radius-card-header">
                <h3 class="my-0">Listado de usuarios</h3>
                <div class="right-wrapper pull-right">
                    <button class="btn btn-default btn-sm  mt-2 mr-2" type="button" @click.prevent="clickCreate()"><i
                        class="fa fa-plus-circle"></i> Agregar
                    </button>
                </div>
            </div>
            <div class="card-body mt-0">
                <div class="row" v-loading="loading">
                    <div class="col-12 table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Email</th>
                                    <th>Nombre</th>
                                    <th>Perfil</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="!users.length">
                                    <tr>
                                        <td colspan="5" class="text-center">No hay usuarios registrados.</td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr v-for="(user, index) in users"
                                        :key="index"
                                        :class="{ 'text-danger' : !user.active }"
                                    >
                                        <td>{{ customIndex(index) }}</td>
                                        <td>{{ user.email }}</td>
                                        <td>
                                            {{ user.name }}
                                            <template v-if="!user.active">
                                                (SUSPENDIDO)
                                            </template>
                                        </td>
                                        <td>{{ user.role }}</td>
                                        <td class="text-right">
                                            <el-button type="primary"
                                                size="mini"
                                                @click.prevent="clickCreate(user.id)"
                                            >
                                                Editar
                                            </el-button>
                                            <template v-if="user.id !== 1">
                                                <el-button type="danger"
                                                    size="mini"
                                                    class="ml-2"
                                                    @click.prevent="clickDelete(user.id)"
                                                >
                                                    Eliminar
                                                </el-button>
                                                <el-button type="warning"
                                                    size="mini"
                                                    class="ml-2"
                                                    @click.prevent="clickDisable(user.id, user.active)"
                                                >
                                                    {{ user.active ? 'Inhabilitar' : 'Habilitar' }}
                                                </el-button>
                                            </template>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <form-users
            :showDialog.sync="showDialogForm"
            :userId="selectedUserId"
        />
    </div>

</template>
<script>
    import formUsers from './form-users.vue'

    export default {
        components: {
            formUsers
        },
        data() {
            return {
                loading: false,
                users: [],
                showDialogForm: false,
                selectedUserId: null
            }
        },
        async created() {
            this.$eventHub.$on('reloadData', async () => {
                await this.getUsers()
            })
            await this.getUsers()
        },
        methods: {
            customIndex(index) {
                return index + 1
            },

            async getUsers() {
                try {
                    this.loading = true
                    const response = await this.$http.get('/users/records')
                    this.users = response.data.data
                } catch (error) {
                    console.error(error)
                    let message = error.response.data.message || 'Ocurrio un error inesperado'
                    this.$message.error(message)
                } finally {
                    this.loading = false
                }
            },

            clickCreate(userId = null) {
                this.showDialogForm = true
                this.selectedUserId = userId
            },

            clickDisable(userId, active) {
                let action = active ? 'inhabilitar' : 'habilitar'
                this.$confirm(`¿Desea ${action} el usuario?`, 'Mensaje de confirmación', {
                    confirmButtonText: active ? 'Inhabilitar' : 'Habilitar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                })
                .then(async () => {
                    const response = await this.$http.post(`/users/change/active/${userId}`, { active: !active })
                    const { data } = response
                    if (data.success) {
                        this.$message.success(data.message || 'El estado del usuario ha sido cambiado exitosamente.')
                        await this.getUsers()
                    } else {
                        this.$message.error(data.message || 'Ocurrió un error al cambiar el estado del usuario.')
                    }
                })
                .catch(error => {
                    if (error.response) {
                        let message = error.response.data.message || 'Ocurrio un error inesperado'
                        this.$message.error(message)
                    }
                })
            },

            clickDelete(userId) {
                this.$confirm('¿Desea eliminar el usuario?', 'Mensaje de confirmación', {
                    confirmButtonText: 'Eliminar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                })
                .then(async () => {
                    const response = await this.$http.delete(`/users/delete/${userId}`)
                    const { data } = response
                    if (data.success) {
                        this.$message.success(data.message || 'El usuario ha sido eliminado exitosamente.')
                        await this.getUsers()
                    } else {
                        this.$message.error(data.message || 'Ocurrio un error al eliminar el usuario.')
                    }
                })
                .catch(error => {
                    if (error.response) {
                        let message = error.response.data.message || 'Ocurrio un error inesperado'
                        this.$message.error(message)
                    }
                })
            }
        },
    }
</script>

<style>
    .custom-radius-card-header {
        border-end-start-radius: 0 !important;
        border-end-end-radius: 0 !important;
    }
</style>


// WEBPACK FOOTER //
// resources/js/views/system/users/index-users.vue